import { render } from "./chat.vue?vue&type=template&id=752ac448"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=752ac448&lang=less"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tgl.liuxianfa.cn\\mobileNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__